import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CatalogProductResponse } from '../../models/product-catalog.model';
import { ProductDetailResponse } from '../../models/product-detail.model';
import { TagMapping } from '../../models/tag-mapping.model';

export const CatalogActions = createActionGroup({
  source: 'Catalog',
  events: {
    'Load Catalog': emptyProps(),
    'Load Catalog Success': props<{ products: CatalogProductResponse[] }>(),
    'Load Catalog Failure': props<{ error: string }>(),

    'Load Product Details': emptyProps(),
    'Load Product Details Success': props<{ productDetails: Record<string, ProductDetailResponse> }>(),
    'Load Product Details Failure': props<{ error: string }>(),

    'Load Product Detail': props<{ code: string }>(),
    'Load Product Detail Success': props<{ code: string; productDetail: ProductDetailResponse }>(),
    'Load Product Detail Failure': props<{ code: string; error: string }>(),

    'Load Tag Mapping': emptyProps(),
    'Load Tag Mapping Success': props<{ tagMapping: TagMapping }>(),
    'Load Tag Mapping Failure': props<{ error: string }>(),
  },
});
